import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ChevronLeft } from "lucide-react";
import { toast } from "sonner";
import { api, fmtDate } from "@/lib/api";
import { LEVEL_COLORS } from "@/lib/organs";
import { SectionTitle } from "@/components/Shared";

const ORGAN_LABEL = {
  immune: "Sistema Immunitario", heart: "Cuore", circulation: "Circolazione",
  digestive: "Apparato Digerente", brain: "Cervello", breathing: "Respiro",
};

function Field({ label, children }) {
  return (
    <div>
      <div className="text-[10px] tracking-[0.2em] text-gray-600 uppercase mb-1">{label}</div>
      <div className="text-sm text-gray-300 leading-relaxed">{children}</div>
    </div>
  );
}

export default function Actions() {
  const [actions, setActions] = useState([]);

  const load = () => api.get("/actions").then((r) => setActions(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const resolve = async (id) => {
    await api.post(`/actions/${id}/resolve`).catch(() => {});
    toast.success("Azione segnata come gestita. DAD aggiorna lo stato dell'azienda.");
    load();
  };

  const open = actions.filter((a) => a.status === "open");
  const done = actions.filter((a) => a.status === "done");

  return (
    <div className="max-w-3xl mx-auto px-4" data-testid="actions-page">
      <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-cyan-300 mb-4"><ChevronLeft size={14} /> Organismo</Link>
      <div className="mb-6 fade-up">
        <p className="text-xs tracking-[0.25em] text-gray-500">COSCIENZA · IMPRENDITORE</p>
        <h1 className="font-display text-3xl font-bold mt-1">Oggi · Azioni</h1>
        <p className="text-sm text-gray-500 mt-1">DAD trasforma l'incertezza in azioni comprensibili. Tu decidi e autorizzi.</p>
      </div>

      <div className="space-y-5">
        {open.map((a, i) => (
          <div key={a.action_id} data-testid={`action-card-${a.action_id}`}
            className="glass rounded-3xl p-6 fade-up" style={{ animationDelay: `${i * 60}ms`, borderLeft: `3px solid ${LEVEL_COLORS[a.level]}` }}>
            <div className="flex items-center gap-2 mb-3 flex-wrap">
              <span className="chip" style={{ color: LEVEL_COLORS[a.level], borderColor: `${LEVEL_COLORS[a.level]}40`, background: `${LEVEL_COLORS[a.level]}12` }}>
                {a.level === "red" ? "INTERVENTO NECESSARIO" : "RICHIEDE ATTENZIONE"}
              </span>
              <span className="chip">{ORGAN_LABEL[a.organ_id] || a.organ_id}</span>
              <span className="chip">Scadenza: {fmtDate(a.deadline)}</span>
            </div>
            <h2 className="font-display font-bold text-lg mb-4">{a.title}</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              <Field label="Perché sta succedendo">{a.why}</Field>
              <Field label="Impatto">{a.impact}</Field>
              <Field label="DAD propone">{a.recommendation}</Field>
              <Field label="Urgenza">{a.urgency}</Field>
              <Field label="Responsabile">{a.owner}</Field>
              <Field label="Fonte / Evidenza">{a.source}</Field>
            </div>
            <div className="mt-5 flex items-center justify-between gap-3 flex-wrap">
              <span className="text-sm font-medium text-cyan-200">Azione richiesta: {a.action_required}</span>
              <button data-testid={`action-resolve-${a.action_id}`} onClick={() => resolve(a.action_id)} className="btn-ghost !text-xs">
                <CheckCircle2 size={14} /> Segna come gestita
              </button>
            </div>
          </div>
        ))}
        {open.length === 0 && (
          <div className="glass rounded-3xl p-10 text-center text-gray-400" data-testid="actions-empty">
            <CheckCircle2 size={32} className="mx-auto mb-3 text-emerald-400" />
            Oggi non è richiesta alcuna azione urgente. DAD continua a monitorare.
          </div>
        )}
      </div>

      {done.length > 0 && (
        <div className="mt-10">
          <SectionTitle>Gestite</SectionTitle>
          <div className="space-y-2 opacity-50">
            {done.map((a) => (
              <div key={a.action_id} className="glass rounded-2xl px-4 py-3 text-sm text-gray-400 flex items-center gap-2">
                <CheckCircle2 size={14} className="text-emerald-400" /> {a.title}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
